import { useState } from 'react'
import api from '../../utils/api'
import useToastContext from '../useToastContext'
import { notificationTypes } from '../../contexts/toastContext'

const useCommunicationsApi = () => {
  const addToast = useToastContext()
  const [communicationsState, setCommunicationsState] = useState({
    communications: {},
    isLoading: false,
    error: null,
  })

  const [createCommunicationState, setCreateCommunicationState] = useState({
    isLoading: false,
    error: null,
  })

  async function getCommunications(params) {
    try {
      setCommunicationsState((currentCommunicationsState) => ({
        ...currentCommunicationsState,
        isLoading: true,
        error: null,
      }))
      const response = await api.get('/communications', {
        params,
        includeToken: true,
      })
      setCommunicationsState({
        communications: {
          data: response.data.data,
          count: response.data.count,
        },
        isLoading: false,
        error: null,
      })
    } catch (error) {
      setCommunicationsState({ communications: null, isLoading: false, error })
    }
  }

  async function createCommunication(communication) {
    try {
      setCreateCommunicationState((currentCreateCommunicationState) => ({
        ...currentCreateCommunicationState,
        isLoading: true,
        error: null,
      }))
      const created = await api.post('/communications', communication)
      setCreateCommunicationState({
        isLoading: false,
        error: null,
      })
      setCommunicationsState({
        communications: {
          data: [
            {
              ...created.data,
              ...(communication.apartmentId && {
                apartmentId: communication.apartmentId,
              }),
              ...(communication.buildingId && {
                buildingId: communication.buildingId,
              }),
            },
            ...(communicationsState.communications.data ?? []),
          ],
          count: communicationsState.communications.count + 1,
        },
        isLoading: false,
        error: null,
      })
      addToast(notificationTypes.success, 'Comunicación creada con exito!')
    } catch (error) {
      console.log(error)
      addToast(
        notificationTypes.error,
        `Error al crear la comunicación: ${error?.response?.data?.message}`
      )
      setCreateCommunicationState({ isLoading: false, error })
    }
  }
  const state = {
    communicationsState,
    createCommunicationState,
  }

  const methods = {
    getCommunications,
    createCommunication,
  }

  return [state, methods]
}

export default useCommunicationsApi
